import * as React from "react";
import {RouteComponentProps} from "react-router";
import {observer} from "mobx-react";
import PersonQualificationRequestEdit from "./PersonQualificationRequestEdit";

type Props = RouteComponentProps<{ entityId: string, addressId?: string }>;

@observer
export class PersonQualificationRequestManagement extends React.Component<Props> {
  static PATH = "/personQualificationRequest";
  static NEW_SUBPATH = "new";

  render() {
    const {entityId, addressId} = this.props.match.params;
    return (
      <>
        <PersonQualificationRequestEdit entityId={entityId} addressId={addressId}/>
      </>
    );
  }
}
